export const DefaultColorsDashboard = [
    '#A7C7E7',
    '#E6CFE6',
    '#F7A8B8',
    '#C1E1C1',
    '#FFDAC1',
    '#C7CEEA',
    '#F9E2AE',
    '#B5EAD7',
    '#FFB7B2',
    '#D7ECD9',
    '#EAD9FF'
]